import { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { usePlatformMessages } from './usePlatformMessages';
import { useMessageAcknowledgement } from './useMessageAcknowledgement';

const styles = {
  INFO: 'border-blue-500/30 bg-blue-950/35 text-blue-100',
  WARNING: 'border-amber-500/30 bg-amber-950/35 text-amber-100',
  CRITICAL: 'border-red-500/40 bg-red-950/40 text-red-100',
};

export function PlatformMessageBanner() {
  const { data = [] } = usePlatformMessages();
  const { acknowledgeLatest, isUnacknowledged } = useMessageAcknowledgement();
  const orderedMessages = useMemo(
    () => [...data].sort((left, right) => right.published_at.localeCompare(left.published_at)),
    [data],
  );
  const message = orderedMessages.find(isUnacknowledged);

  const acknowledge = () => acknowledgeLatest(orderedMessages);

  if (!message) return null;

  return (
    <div role="status" className={`mx-4 mt-4 flex items-start gap-3 rounded-xl border px-4 py-3 ${styles[message.severity]}`}>
      <div className="min-w-0 flex-1">
        <p className="text-sm font-semibold">{message.title}</p>
        <p className="mt-0.5 line-clamp-2 text-sm opacity-80">{message.body}</p>
        <Link to="/messages" onClick={acknowledge} className="mt-1 inline-block text-xs font-medium underline underline-offset-2">View all messages</Link>
      </div>
      <button
        type="button"
        onClick={acknowledge}
        aria-label="Dismiss message"
        className="rounded px-2 py-1 text-sm opacity-70 hover:bg-white/10 hover:opacity-100"
      >×</button>
    </div>
  );
}
